import styled, { css } from 'styled-components';

import { StyledFormControl } from '../FormControl';
import StyledInput from '../Input/Input.styles';
import { StyledText } from '../Text/Text';
import { defaultThemeProp } from '../../theme';
import { StyledButton } from '../Button';
import { StyledFlex } from '../Flex';

type StyledStepperProps = { size: number; unitPlacement: 'before' | 'after' };

export const StyledStepperInput = styled(StyledFormControl)<StyledStepperProps>(props => {
  const {
    theme: {
      base: { spacing, 'border-radius': baseBorderRadius },
      components: {
        input: { height },
        'form-control': {
          'border-radius': formBorderRadius,
          'foreground-color': fgColor,
          'border-width': borderWidth,
          ':focus': { 'border-color': focusBorderColor, 'box-shadow': shadow }
        }
      }
    },
    size,
    unitPlacement
  } = props;
  return css`
    &:focus-within:not([disabled]) {
      border-color: ${focusBorderColor};
      box-shadow: ${shadow};
    }
    ${StyledFlex} {
      overflow: auto;
      margin-inline-start: ${spacing};
      margin-inline-end: ${spacing};
    }
    ${StyledInput} {
      width: ${size}ch;
      min-width: 1ch;
      border: 0;
      padding: 0;
      text-align: ${unitPlacement === 'after' ? 'end' : 'start'};
      &:focus:not([disabled]) {
        box-shadow: none;
      }
    }
    ${StyledText} {
      padding: 0 calc(0.5 * ${spacing});
      white-space: nowrap;
    }
    > ${StyledButton} {
      border-radius: calc(${baseBorderRadius} * ${formBorderRadius});
      margin-inline-start: auto;
      border: 0;
      &:enabled {
        color: ${fgColor};
      }
      min-height: calc(${height} - 2 * ${borderWidth});
      height: calc(${height} - 2 * ${borderWidth});
    }
  `;
});

StyledStepperInput.defaultProps = defaultThemeProp;

const StyledNumberInput = styled(StyledFormControl)(props => {
  const {
    theme: {
      base: { spacing },
      components: {
        'form-control': {
          ':focus': { 'border-color': focusBorderColor, 'box-shadow': shadow }
        }
      }
    }
  } = props;

  return css`
    padding: 0 calc(0.5 * ${spacing});
    &:focus-within:not([disabled]) {
      border-color: ${focusBorderColor};
      box-shadow: ${shadow};
    }
    ${StyledInput} {
      border: 0;
      padding: 0 calc(0.5 * ${spacing});
      &:focus:not([disabled]) {
        box-shadow: none;
      }
    }
    ${StyledText} {
      padding: 0 calc(0.5 * ${spacing});
      white-space: nowrap;
    }
  `;
});

StyledNumberInput.defaultProps = defaultThemeProp;

export default StyledNumberInput;
